// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"8":"0c42064ec9c8a64d","5567":"b85e5b8ddf2f76c4","6857":"b05ca78c41fecdb5"}[chunkId] + ".css";
};